<template>
  <div>
    <form @submit.prevent="scrapeUsingBookTitle" autocomplete="off">
      <div class="form-row justify-content-center">
        <Column md="4">
          <mdb-input label="Book Title" v-model="inputtedBookTitle" required :disabled="scrapingInProgress"/>
        </Column>
        <Column md="1">
          <mdb-btn class="mt-md-3" type="submit" :disabled="scrapingInProgress">Submit</mdb-btn>
        </Column>
      </div>
    </form>

    <div class="row justify-content-md-center">
      <p>Or click <a class="text-default" href="javascript:;" v-on:click="toggleURLFormVisibility">here</a> to enter the
        SparkNotes URL</p>
    </div>

    <form @submit.prevent="scrapeUsingSparkNotesURL" novalidate v-if="isURLFormVisible" autocomplete="off">
      <div class="form-row justify-content-center">
        <Column md="4">
          <mdb-input v-model="inputtedURL" name="URL"  label="SparkNotes URL" :disabled="scrapingInProgress" v-validate="{ required: true, regex: /^https:\/\/www\.sparknotes\.com\/lit\/[\w-]+\// }"/>
        </Column>
        <Column md="1">
          <mdb-btn class="mt-md-3" type="submit" :disabled="errors.any() || scrapingInProgress">Submit</mdb-btn>
        </Column>
      </div>
      <div class="form-row justify-content-center">
        <p class="message-invalid" v-if="errors.has('URL')">{{ errors.first('URL') }}</p>
      </div>
    </form>
  </div>
</template>
<style>
</style>
<script>
  import {Validator} from 'vee-validate';
  import {Column, mdbInput, mdbBtn} from 'mdbvue';

  const dict = {
  custom: {
    URL: {
      regex: 'Please provide a URL of the form https://www.sparknotes.com/lit/xxxxxx/'
    },
  }
};

Validator.localize('en', dict);

export default {
name: 'Home',
  components: {
    mdbInput,
    Column,
    mdbBtn
  },
  data () {
      return {
        inputtedBookTitle: '',
        inputtedURL: '',
        scrapingInProgress: false,
        isURLFormVisible: false
      }
    },
  methods: {
    toggleURLFormVisibility() {
      this.isURLFormVisible = !this.isURLFormVisible
    },
    scrapeUsingBookTitle() {
      this.scrapingInProgress = true
      var requestBody = {
        "book_title": this.inputtedBookTitle
      }
      this.startScraping(requestBody)
    },
    scrapeUsingSparkNotesURL() {
      this.$validator.validateAll().then((result) => {
       if (result) {
         this.scrapingInProgress = true
         var requestBody = {
           "sparknotes_url": this.inputtedURL
         }
         this.startScraping(requestBody)
        }
      })},
    startScraping(requestBody) {
      this.$http.post('/start', requestBody)
        .then(data => {
          var jobId = data.data

          this.$sessionStorage.set("jobId", jobId)

          this.pollJobProgress(jobId)
        })
        .catch(() => this.displayFailureDialog())
    },
    pollJobProgress(jobID) {
      var poller = () => {
        this.$http.get('/status/' + jobID)
          .then((json) => {
            var object = json.data

            if (object["has_failed"]) {
              this.displayFailureDialog()
              clearInterval(interval)
              NProgress.done()
              return
            }

            var progress = parseFloat(object["progress"]);
            NProgress.set(progress);

            if (progress === 1.0) {
              clearInterval(interval)
              this.$router.replace('/download')
            }

          })
          .catch((e) => this.displayFailureDialog())
      }

      var interval = setInterval(poller, 1000)
    },
    displayFailureDialog() {
      alert("Scraping has failed - please try again")
      this.scrapingInProgress = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue